import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ApiKeyVaultRootParamList,
  CreateNewApiVaultKeyRootParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { CreateNewApiVaultKeyScreen } from "./CreateNewApiVaultKeyScreen";
import { SelectApiKeyTypeScreen } from "./SelectApiKeyTypeScreen";
import { ApiVaultKeyForm } from "../../components/ApiVaultKeyForm";

export interface CreateNewApiVaultKeyScreenProps
  extends StackScreenProps<
    ApiKeyVaultRootParamList,
    "CreateNewApiVaultKeyRootScreen"
  > {}

const Stack = createStackHeaderNavigator<CreateNewApiVaultKeyRootParamList>();

export const CreateNewApiVaultKeyRootScreen = ({
  navigation,
}: CreateNewApiVaultKeyScreenProps) => {
  return (
    <ApiVaultKeyForm.Provider>
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Group
          screenOptions={{
            headerLeft: () => <ModalCloseButton type="Back" />,
            title: "",
          }}
        >
          <Stack.Screen
            name="CreateNewApiVaultKeyScreen"
            component={CreateNewApiVaultKeyScreen}
            options={{
              headerLeft: () => <ModalCloseButton type="Cancel" />,
            }}
          />
          <Stack.Screen
            name="SelectApiKeyTypeScreen"
            component={SelectApiKeyTypeScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </ApiVaultKeyForm.Provider>
  );
};
